export const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

let baseUrl = import.meta.env.VITE_BASE_URL;

export const buildUrl = (apiPath, placeholders = []) => {
  let path = apiPath;

  placeholders.forEach((placeholder) => {
    const { name, value } = placeholder;
    const placeholderPattern = new RegExp(`:${name}`, 'g');
    path = path.replace(placeholderPattern, value);
  });

  return `${baseUrl}${path}`;
};

export const generateSenderIconBgColor = (sender) => {
  const str = `${sender?.name}${sender?.id}`;

  return generateIconBgColor(str);
};

export const generateIconBgColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    value = Math.max(Math.min(value, 200), 50); // Ensure each color component is between 50 and 200, so the background is not too light or dark
    color += ('00' + value.toString(16)).slice(-2);
  }
  return color;
};

export const getSubdomain = () => {
  const host = window.location.hostname;
  const parts = host.split('.');
  if (parts.length == 3 || (parts.length == 2 && parts[1] == 'localhost')) {
    return parts[0];
  }
  return null;
};

export const getAbsoluteURL = (url) => {
  const isAbsoluteOrDataURL = url.startsWith('http') || url.startsWith('data:');

  if (isAbsoluteOrDataURL) {
    return url;
  }

  return `${import.meta.env.VITE_BASE_URL}${url}`;
};

export const prettifyResponseMessage = (content) => {
  if (!content) return content;

  // Ensure think tag closes with a newline before
  return content.replaceAll('</think>', '\n</think>');
};
